import { render, staticRenderFns } from "./RoundButton.vue?vue&type=template&id=33deac2a&scoped=true"
import script from "./RoundButton.vue?vue&type=script&lang=js"
export * from "./RoundButton.vue?vue&type=script&lang=js"
import style0 from "./RoundButton.vue?vue&type=style&index=0&id=33deac2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33deac2a",
  null
  
)

export default component.exports